const chargesKey = ['charges'] as const

export const chargesKeys = {
  all: chargesKey,
  list: (params: (string | number | boolean | null | undefined)[]) =>
    [...chargesKey, 'list', ...params] as const,
}
